function copypaste() {
  var copyText = document.getElementById("codecopy");
  navigator.clipboard.writeText(copyText.textContent).then(() => {
    // Show copied message
    var message = document.querySelector('.code-container__copy-message');
    message.classList.remove('hide');
    
    // Hide the message after 2 seconds
    setTimeout(() => message.classList.add('hide'), 2000);
  });
}